module.exports = __webpack_public_path__ + "img/cases-brand-yanghe-2.6c714a36.jpg";